import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useUserPermissions } from '../hooks/useUserPermissions';

interface SupportTicketsRouteProps {
  children?: React.ReactNode;
}

/**
 * Route guard for Support Tickets pages
 * Requires the user to have 'messages.all' permission
 * Redirects to the home page if permission is missing
 */
export const SupportTicketsRoute: React.FC<SupportTicketsRouteProps> = ({ children }) => {
  const { hasPermission, isLoading } = useUserPermissions();
  
  // Show loading while checking permissions
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }
  
  // Check for Support Tickets permission
  if (!hasPermission('messages.all')) {
    return <Navigate to="/" replace />;
  }
  
  return <>{children || <Outlet />}</>;
};